export { isCurrencyPlaceOnRight } from './isCurrencyPlaceOnRight';
